import { app } from '../../app.module'
app
  /**
   * 特定の処理でテキストフォームにフォーカスさせる
   * ex.shouldBeOpenがtrueの場合自動的にフォーカス
   * <input type="text" focus-me="shouldBeOpen">
   */
  .directive('focusMe', function ($timeout, $parse) {
    return {
      link: function (scope, element, attrs) {
        const model = $parse(attrs.focusMe)
        scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus()
            })
          }
        })
      },
    }
  })
